import React, { useEffect, useState, useRef } from "react";
import Header from "./Header/Header";
import Menu from "./Menu/Menu";
import WatchlistCard from "./WatchlistCard/WatchlistCard";
import ReactDragListView from "react-drag-listview";
import useSize from "../../../Utils/useSize/useSize";
import Backend from "../../../Backend/Backend";
import toast from "react-hot-toast";
import { Dialog } from "primereact/dialog";
import Loading from "../../../Utils/Loading/Loading";
import BuySell from "./BuySell/BuySell";
import useSound from "use-sound";
import ErrorSoundFile from "../../../Sound/Error.wav";
import NotFound from "../../../Utils/NotFound/NotFound";
import Key from "../../../Utils/Key/Key";

import "../../../Utils/Css/Watchlist.css";

const backend = await new Backend().init();

export default function Watchlist() {
  const [play] = useSound(ErrorSoundFile);
  const windowSize = useSize();

  const [loading, setLoading] = useState(true);
  const [buySellModalOpen, setBuySellModalOpen] = useState(false);
  const [buySellType, setBuySellType] = useState(0);

  const [selectedId, setSelectedId] = useState(0);
  const [selectedSymbol, setSelectedSymbol] = useState(null);

  const [watchlistType, setWatchlistType] = useState("WATCHLIST");

  const [watchlist, setWatchlist] = useState([]);
  const [originalWatchlist, setOriginalWatchlist] = useState([]);

  const [nse_future_active, setNseFutureActive] = useState(0);
  const [nse_future_symbol, setNseFutureSymbol] = useState([]);

  const [nse_cash_active, setNseCashActive] = useState(0);
  const [nse_cash_symbol, setNseCashSymbol] = useState([]);  

  const [mcx_future_active, setMcxFutureActive] = useState(0);
  const [mcx_future_symbol, setMcxFutureSymbol] = useState([]);

  const [mcx_options_active, setMcxOptionsActive] = useState(0);
  const [mcx_options_symbol, setMcxOptionsSymbol] = useState([]);  

  const [nse_options_active, setNseOptionsActive] = useState(0);
  const [nse_options_symbol, setNseOptionsSymbol] = useState([]);

  const [crypto_active, setCryptoActive] = useState(0);
  const [crypto_symbol, setCryptoSymbol] = useState([]);

  const [comex_active, setComexActive] = useState(0);
  const [comex_symbol, setComexSymbol] = useState([]);

  const [forex_active, setForexActive] = useState(0);
  const [forex_symbol, setForexSymbol] = useState([]);

  const [index_active, setIndexActive] = useState(0);
  const [index_symbol, setIndexSymbol] = useState([]);

  const [us_stock_active, setUsStockActive] = useState(0);
  const [us_stock_symbol, setUsStockSymbol] = useState([]);

  const [sgx_active, setSgxActive] = useState(0);
  const [sgx_symbol, setSgxSymbol] = useState([]);

  const [dgcx_active, setDgcxActive] = useState(0);
  const [dgcx_symbol, setDgcxSymbol] = useState([]);
  
  const [ncdex_active, setNcdexActive] = useState(0);
  const [ncdex_symbol, setNcdexSymbol] = useState([]);  

  const [symbols, setSymbols] = useState([]);

  const debounceTimeout = useRef(null);

  // Sync selectedSymbol whenever selectedId or watchlist changes
  useEffect(() => {
    if (selectedId > 0 && watchlist.length >= selectedId) {
      setSelectedSymbol(watchlist[selectedId - 1]);
    } else {
      setSelectedSymbol(null);
    }
  }, [selectedId, watchlist]);

  // Load symbols when watchlistType changes
  useEffect(() => {
    if (watchlistType === "NSE-FUTURE") {
      setWatchlist(nse_future_symbol);
      setOriginalWatchlist(nse_future_symbol);
      setSelectedId(nse_future_symbol.length > 0 ? 1 : 0);
    } else if (watchlistType === "NSE-EQUITY") {
      setWatchlist(nse_cash_symbol);
      setOriginalWatchlist(nse_cash_symbol);
      setSelectedId(nse_cash_symbol.length > 0 ? 1 : 0);      
    } else if (watchlistType === "MCX-FUTURE") {
      setWatchlist(mcx_future_symbol);
      setOriginalWatchlist(mcx_future_symbol);
      setSelectedId(mcx_future_symbol.length > 0 ? 1 : 0);
    } else if (watchlistType === "MCX-OPTIONS") {
      setWatchlist(mcx_options_symbol);
      setOriginalWatchlist(mcx_options_symbol);
      setSelectedId(mcx_options_symbol.length > 0 ? 1 : 0);      
    } else if (watchlistType === "NSE-OPTIONS") {
      setWatchlist(nse_options_symbol);
      setOriginalWatchlist(nse_options_symbol);
      setSelectedId(nse_options_symbol.length > 0 ? 1 : 0);
    } else if (watchlistType === "COMEX") {
      setWatchlist(comex_symbol);
      setOriginalWatchlist(comex_symbol);
      setSelectedId(comex_symbol.length > 0 ? 1 : 0);
    } else if (watchlistType === "CRYPTO") {
      setWatchlist(crypto_symbol);
      setOriginalWatchlist(crypto_symbol);
      setSelectedId(crypto_symbol.length > 0 ? 1 : 0);
    } else if (watchlistType === "FOREX") {
      setWatchlist(forex_symbol);
      setOriginalWatchlist(forex_symbol);
      setSelectedId(forex_symbol.length > 0 ? 1 : 0);
    } else if (watchlistType === "US-STOCK") {
      setWatchlist(us_stock_symbol);
      setOriginalWatchlist(us_stock_symbol);
      setSelectedId(us_stock_symbol.length > 0 ? 1 : 0);
    } else if (watchlistType === "SGX") {
      setWatchlist(sgx_symbol);
      setOriginalWatchlist(sgx_symbol);
      setSelectedId(sgx_symbol.length > 0 ? 1 : 0);
    } else if (watchlistType === "OTHERS") {
      setWatchlist(index_symbol);
      setOriginalWatchlist(index_symbol);
      setSelectedId(index_symbol.length > 0 ? 1 : 0);
    } else if (watchlistType === "DGCX") {
      setWatchlist(dgcx_symbol);
      setOriginalWatchlist(dgcx_symbol);
      setSelectedId(dgcx_symbol.length > 0 ? 1 : 0);
    } else if (watchlistType === "NCDEX") {
      setWatchlist(ncdex_symbol);
      setOriginalWatchlist(ncdex_symbol);
      setSelectedId(ncdex_symbol.length > 0 ? 1 : 0);
    } else {
      loadSymbols();
    }
  }, [watchlistType]);

  const loadSymbols = () => {
    setLoading(true);
    const data = {
      server: localStorage.getItem("server"),
      id: localStorage.getItem("id"),
      user_id: localStorage.getItem("id"),
      username: localStorage.getItem("username"),
      token: localStorage.getItem("token"),
      watchlist_id: "1",
    };

    backend.watchlist(data).then((r) => {
      setLoading(false);
      if (r.error === "False") {
        setWatchlist(r.watchlist);
        setOriginalWatchlist(r.watchlist);
        setSelectedId(r.watchlist.length > 0 ? 1 : 0);

        setNseFutureActive(r.nse_future);
        setNseFutureSymbol(r.nse_future_symbol);

        setNseCashActive(r.nse_equity);
        setNseCashSymbol(r.nse_equity_symbol);

        setMcxFutureActive(r.mcx_future);
        setMcxFutureSymbol(r.mcx_future_symbol);

        setMcxOptionsActive(r.mcx_options);
        setMcxOptionsSymbol(r.mcx_options_symbol);        

        setNseOptionsActive(r.nse_options);
        setNseOptionsSymbol(r.nse_options_symbol);

        setComexActive(r.comex);
        setComexSymbol(r.comex_symbol);

        setCryptoActive(r.crypto);
        setCryptoSymbol(r.crypto_symbol);

        setForexActive(r.forex);
        setForexSymbol(r.forex_symbol);

        setUsStockActive(r.us_stock);
        setUsStockSymbol(r.us_stock_symbol);

        setSgxActive(r.sgx);
        setSgxSymbol(r.sgx_symbol);

        setIndexActive(r.index);
        setIndexSymbol(r.index_symbol);

        setDgcxActive(r.dgcx);
        setDgcxSymbol(r.dgcx_symbol);

        setNcdexActive(r.ncdex);
        setNcdexSymbol(r.ncdex_symbol);

        setSymbols(r.symbols);
      } else {
        if (r.logout === 1) {
          window.LogOut();
        } else {
          play();
          toast.error(r.message);
        }
      }
    });
  };

  const onDragEnd = (fromIndex, toIndex) => {
    const reordered = [...watchlist];
    const item = reordered.splice(fromIndex, 1)[0];
    reordered.splice(toIndex, 0, item);
    setWatchlist(reordered);

    // Adjust selectedId if necessary
    if (selectedId === fromIndex + 1) {
      setSelectedId(toIndex + 1);
    } else if (
      selectedId > Math.min(fromIndex, toIndex) &&
      selectedId <= Math.max(fromIndex, toIndex)
    ) {
      if (fromIndex < toIndex) setSelectedId(selectedId - 1);
      else setSelectedId(selectedId + 1);
    }
  };

  const updateSelectedId = (index) => {
    setSelectedId(index);
  };

  const handleSearch = (value) => {
    clearTimeout(debounceTimeout.current);
    debounceTimeout.current = setTimeout(() => {
      if (value.length > 2) {
        const filtered = originalWatchlist.filter((item) =>
          item.symbol_display.toLowerCase().includes(value.toLowerCase())
        );
        setWatchlist(filtered);
        setSelectedId(filtered.length > 0 ? 1 : 0);
      } else {
        setWatchlist(originalWatchlist);
        setSelectedId(originalWatchlist.length > 0 ? 1 : 0);
      }
    }, 300);
  };

  const openBuySellModal = (type) => {
    if (selectedSymbol) {
      setBuySellType(type);
      setBuySellModalOpen(true);
    }
  };

  // Keyboard shortcuts
  const keyHandlers = {
    buy: () => openBuySellModal(0),
    sell: () => openBuySellModal(1),
    up: () => setSelectedId((prev) => Math.max(1, prev - 1)),
    down: () => setSelectedId((prev) => Math.min(watchlist.length, prev + 1)),
    one: () => setWatchlistType("WATCHLIST"),
    esc: () => {
      setBuySellModalOpen(false);
    },
  };

  return (
    <div>
      <Header
        onChangeLink={setWatchlistType}
        onLoad={loadSymbols}
        onSearch={handleSearch}
        watchlistType={watchlistType}
        nse_future_active={nse_future_active}
        nse_cash_active={nse_cash_active}
        mcx_future_active={mcx_future_active}
        mcx_options_active={mcx_options_active}
        nse_options_active={nse_options_active}
        crypto_active={crypto_active}
        comex_active={comex_active}
        forex_active={forex_active}
        us_stock_active={us_stock_active}
        sgx_active={sgx_active}
        index_active={index_active}
        dgcx_active={dgcx_active}
        ncdex_active={ncdex_active}
        symbolsList={symbols}
      />

      <Key {...keyHandlers} />
      <Menu />

      <ReactDragListView
        onDragEnd={onDragEnd}
        nodeSelector="li"
        handleSelector="li"
      >
        <div
          style={{
            width: windowSize[0],
            height: windowSize[1] - 180,
            overflowY: "scroll",
            display: "flex",
            flexDirection: "column",
          }}
        >
          {loading ? (
            <div className="loadingContainer">
              <Loading height={windowSize[1] - 180} />
            </div>
          ) : watchlist.length > 0 ? (
            <div
              style={{
                width: windowSize[0],
                height: windowSize[1] - 180,
                overflowY: "scroll",
              }}
            >
              {watchlist.map((item, index) => (
                <WatchlistCard
                  key={item.id || item.symbol_id || index}
                  id={selectedId}
                  type={watchlistType}
                  item={item}
                  index={index + 1}
                  updateId={updateSelectedId}
                  buy={() => openBuySellModal(0)}
                  sell={() => openBuySellModal(1)}
                  reload={loadSymbols}
                />
              ))}
            </div>
          ) : (
            <NotFound
              height={windowSize[1] - 180}
              title={"Nothing here"}
              subtext={"Use the search bar to add instruments."}
            />
          )}
        </div>
      </ReactDragListView>

      <Dialog
        visible={buySellModalOpen}
        closeOnEscape
        closeIcon
        onHide={() => setBuySellModalOpen(false)}
        className="modal"
        id="modal"
        position="center"
        transitionOptions={false}
        focusOnShow={false}
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          width: windowSize[0],
          height: windowSize[1] - 100,
        }}
      >
        <div
          style={{
            height: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "flex-end",
          }}
        >
          <BuySell
            buysell={buySellModalOpen}
            symbolData={selectedSymbol}
            close={() => setBuySellModalOpen(false)}
            buyselltype={buySellType}
          />
        </div>
      </Dialog>
    </div>
  );
}
